<template>
  <tr class="upcoming-reservation__item">
    <td class="v-align-middle" :class="backgroundType(booking)">
      <ul>
        <li><strong>{{ bookingType(booking) }}</strong><span v-if="bookingType(booking) === 'Indisponibilité'"> : {{ booking.reason }}</span></li>
        <li v-if="booking.suborder">Produit : {{ booking.suborder.text }}</li>
        <li v-else-if="booking.global === false">Produit : {{ booking.product_name}}</li>
        <li v-else>Produit : Tous les bureaux</li>
        <li v-if="bookingType(booking) === 'Réservation'">Client : {{ booking.suborder.suborderable.customer.name }}</li>
        <li v-if="bookingType(booking) === 'Réservation' && mainRepresentative">Téléphone : {{ mainRepresentative.mobile_phone || mainRepresentative.phone }}</li>
        <li v-else-if="bookingType(booking) === 'Réservation'"><span class="text-danger">Aucun représentant légal associé au client</span></li>
        <li v-if="bookingType(booking) === 'Réservation'">le {{ booking.start_date | dmy }}</li>
        <li v-if="bookingType(booking) === 'Réservation'">de {{ booking.start_date | hoursPlusMinutes }} à {{ booking.end_date | hoursPlusMinutes }}</li>
        <li v-if="bookingType(booking) === 'Indisponibilité'">du {{ booking.start_date | dmy }} à {{ booking.start_date | hoursPlusMinutes }}</li>
        <li v-if="bookingType(booking) === 'Indisponibilité'">au {{ booking.end_date | dmy }} à {{ booking.end_date | hoursPlusMinutes }}</li>
        <li></li>
        <li><span v-if="booking.cancelled_at" class="label label-success">Annulée le {{ booking.cancelled_at | dmy }} à {{ booking.cancelled_at | hoursPlusMinutes }}</span></li>
        <!-- <li>Options : Petit Déjeuner x 2</li> -->
      </ul>
    </td>
    <td class="v-align-middle" :class="backgroundType(booking)">
      <button v-if="booking.product_id" class="btn btn-sm btn-complete">Détail</button>
    </td>
  </tr>
</template>

<style lang="scss" scoped>
.upcoming-reservation__item {
  &:hover {
    cursor: pointer;
  }
}
tr {
    td {
        height: 45px;
            &:nth-child(2) {
        width: 50px;
        }
    }
}
.unavailability {
    background: #efefef !important;
}
</style>

<script type="text/babel">
export default {
  name: 'OneTimeLocationsUpcomingReservationsItem',
  props: ['booking'],
  mounted () {},
  filters: {
    hoursPlusMinutes (date) {
      let ISODate = new Date(date)
      let hours = ISODate.getHours()
      let minutes = ISODate.getMinutes() < 10 ? '0' + ISODate.getMinutes() : ISODate.getMinutes()
      return hours + 'h' + minutes
    },
    dmy (date) {
      let ISODate = new Date(date)
      var day = ISODate.getDate() < 10 ? '0' + ISODate.getDate() : ISODate.getDate()
      var month = ISODate.getMonth() < 10 ? '0' + parseInt(ISODate.getMonth() + 1) : parseInt(ISODate.getMonth() + 1)
      var year = ISODate.getFullYear()

      return day + '/' + month + '/' + year
    }
  },
  computed: {
    mainRepresentative () {
      return this.booking.suborder.suborderable.customer.main_representative;
    }
  },
  methods : {
      bookingType (booking) {
          return _.has(booking, 'global') ? 'Indisponibilité' : 'Réservation'
      },
      backgroundType (booking) {
          return _.has(booking, 'global') ? 'unavailability' : 'booking'
      }
  },
}
</script>



// WEBPACK FOOTER //
// client/components/OneTimeLocations/OneTimeLocationsUpcomingReservationsItem.vue